import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyBAjnQWcthqKQ-HikglIyAjuZWnMcKF9_U',
  authDomain: 'dagslys-dc425.firebaseapp.com',
  projectId: 'dagslys-dc425',
  storageBucket: 'dagslys-dc425.appspot.com',
  messagingSenderId: '757550945459',
  appId: '1:757550945459:web:edbaa4df48460a3cf44cc6',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Optional: Connect to emulators in development
if (location.hostname === 'localhost') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export { app, auth, db, functions };